export default {
    path: '/display/main/home',
    component: () => import('@/layout/default/index.vue'),
    children: [
        {
            path: '/',
            component: () => import('@/pages/display/main/home/index.vue')
        }
    ]
};
